<template>
    <div class="mainContent dashboard">
        <div class="recentFAQs frameMobile">

            <h2>{{'pages/faq.title' | trans }}</h2>

            <div class="faqContent" style="margin-bottom: 10px">
                <FAQGroup
                    v-for="faq in faqs"
                    v-if="faq.hasOwnProperty('title')"
                    :key="faq.title"
                    v-bind="faq"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import FAQGroup from "../components/FAQ/FAQGroup";

    export default {
        computed: {
            ...mapState(['faqs', 'faqsLoading']),
        },
        components: {FAQGroup},
        mounted() {
            if (typeof(this.faqs) == "undefined" || !this.faqs.length) {
                this.$store.dispatch('getFAQs');
            }
        },
        updated: function () {
            this.$nextTick(function () {
                //Scroll to group element
                if (typeof(this.$route.query.show) == "string" && this.$route.query.show > '') {
                    console.log(document.getElementById(this.$route.query.show));
                    document.getElementById(this.$route.query.show).scrollIntoView({
                        block: "start",
                        inline: "nearest",
                        behavior: 'smooth'
                    });
                }
                //plan summary component on mobile dynamic height
                checkWindowWidth();
            })
        }
    }
</script>
